import { useEffect, useMemo, useState } from 'react'
import { Image } from '@/atoms/Image'
import { useTranslate } from '@/utils/translate/translate-client'

const STONE_BADGE_URL = '/v1760674855/theatrical/david/stone-pill-badge-yellow'

export function NameInCreditsCountdown() {
  const { t } = useTranslate('pif')

  // Target cutoff: Nov 10, 2025 11:59 PM MST (UTC-7) => 2025-11-11 06:59:00 UTC
  const TARGET_UTC_MS = Date.UTC(2025, 10, 11, 6, 59, 0, 0)
  const [remainingMs, setRemainingMs] = useState<number>(() => Math.max(0, TARGET_UTC_MS - Date.now()))
  const [isClient, setIsClient] = useState<boolean>(false)

  useEffect(() => {
    setIsClient(true)
    const tick = () => {
      const msLeft = Math.max(0, TARGET_UTC_MS - Date.now())
      setRemainingMs(msLeft)
    }
    const intervalId = setInterval(tick, 1000)
    tick()
    return () => clearInterval(intervalId)
  }, [TARGET_UTC_MS])

  const formattedCountdown = useMemo(() => {
    const msPerMinute = 60 * 1000
    const msPerHour = 60 * msPerMinute
    const msPerDay = 24 * msPerHour

    let ms = remainingMs
    const days = Math.floor(ms / msPerDay)
    ms -= days * msPerDay
    const hours = Math.floor(ms / msPerHour) // 0-23
    ms -= hours * msPerHour
    const minutes = Math.floor(ms / msPerMinute) // 0-59
    ms -= minutes * msPerMinute
    const seconds = Math.floor(ms / 1000) // 0-59

    const DD = String(days).padStart(2, '0')
    const HH = String(hours).padStart(2, '0')
    const MM = String(minutes).padStart(2, '0')
    const SS = String(seconds).padStart(2, '0')
    return `${DD}:${HH}:${MM}:${SS}`
  }, [remainingMs])

  return (
    <div className="relative h-[36px] w-full max-w-[282px] md:mx-0 md:h-[44px] md:max-w-[345px]">
      <Image src={STONE_BADGE_URL} alt="" fill className="object-contain" />
      <div className="absolute inset-0 flex items-center justify-center gap-3 px-6">
        <span className="whitespace-nowrap font-['Angel_Royal_Loudes'] text-[26px] font-normal lowercase leading-[24px] text-[#411E09] [font-feature-settings:'liga'_off,'clig'_off] [font-variant-ligatures:none] md:text-[30px] md:leading-[28px]">
          {t('nameInCreditsLimitedTimeEndsIn', 'limited time - ends in:')}
        </span>
        <span className="relative inline-block">
          <span
            aria-hidden="true"
            className="pointer-events-none invisible select-none whitespace-nowrap font-['Angel_Royal_Loudes'] text-[26px] font-normal lowercase tabular-nums leading-[24px] text-[#411E09] [font-feature-settings:'liga'_off,'clig'_off] [font-variant-ligatures:none] md:text-[30px] md:leading-[28px]"
          >
            88:88:88:88
          </span>
          <span className="absolute left-0 top-0 whitespace-nowrap font-['Angel_Royal_Loudes'] text-[26px] font-normal lowercase tabular-nums leading-[24px] text-[#411E09] [font-feature-settings:'liga'_off,'clig'_off] [font-variant-ligatures:none] md:text-[30px] md:leading-[28px]">
            {isClient ? formattedCountdown : '88:88:88:88'}
          </span>
        </span>
      </div>
    </div>
  )
}
